<template>
  <div class="px-3 py-2 text-center">
    <div class="fs-4 fw-normal mt-2">{{ title }}</div>
    <div class="py-2 fs-3 my-3 alert-msg">{{ content }}</div>
    <ion-button class="mb-2" size="small" color="primary" expand="block" @click="$emit('confirm-yes-action')">
      {{ yesLabel ? yesLabel : $t('yes') }}
    </ion-button>
    <ion-button size="small" color="grey2" expand="block" @click="$emit('confirm-no-action')">
      {{ noLabel ? noLabel : $t('no') }}
    </ion-button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ModalContentConfirm',
  props: ['title', 'content', 'yesLabel', 'noLabel'],
  emits: ['confirm-yes-action', 'confirm-no-action']
});
</script>
<style scoped>
.alert-msg {
  line-height: 1.5;
}
ion-button {
  --border-radius: 8px;
}
</style>
